export const mockedData = {
  leader_sound_enable: true,
  total_deposit: 54320.75,
  total_deposit_count: 112,
  total_deposit_chart: [5000, 7500, 8000, 6000, 7000, 9000, 10820.75],
  total_goal: 100000,
  remaining_goal: 45679.25,
  complete_percentage: 54.32,
  leader_sound: "leader_sound.mp3",
  agents_list: [
    {
      agent_first_name: "Jane",
      agent_last_name: "Smith",
      agent_id: 1,
      deposit_count: 12,
      deposit_amount: 4500,
      deposit_amount_approved: 4000,
      deposit_amount_pending: 500.5,
      deposit_amount_rejected: 740,
      withdraw_amount: 2500,
      withdraw_amount_approved: 2000,
      withdraw_amount_pending: 500,
      withdraw_amount_rejected: 114,
      total_clients: 13,
      total_positions: 2982.14,
      transaction_chart: [300, 400, 500, 600, 700]
    },
    {
      agent_first_name: "John",
      agent_last_name: "Doe",
      agent_id: 5,
      deposit_count: 18,
      deposit_amount: 8000,
      deposit_amount_approved: 7500,
      deposit_amount_pending: 500,
      deposit_amount_rejected: 280,
      withdraw_amount: 3000,
      withdraw_amount_approved: 2800,
      withdraw_amount_pending: 200,
      withdraw_amount_rejected: 250,
      total_clients: 5,
      total_positions: 20119.74,
      transaction_chart: [500, 600, 700, 800, 900]
    },
    {
      agent_first_name: "Alice",
      agent_last_name: "Johnson",
      agent_id: 6,
      deposit_count: 10,
      deposit_amount: 3000,
      deposit_amount_approved: 2800,
      deposit_amount_pending: 200,
      deposit_amount_rejected: 640,
      withdraw_amount: 1200,
      withdraw_amount_approved: 1100,
      withdraw_amount_pending: 100,
      withdraw_amount_rejected: 300,
      total_clients: 4,
      total_positions: 800,
      transaction_chart: [400, 300, 500]
    },
    {
      agent_first_name: "Ella",
      agent_last_name: "Cooper",
      agent_id: 10,
      deposit_count: 15,
      deposit_amount: 4200,
      deposit_amount_approved: 4000,
      deposit_amount_pending: 200,
      deposit_amount_rejected: 450,
      withdraw_amount: 1500,
      withdraw_amount_approved: 1300,
      withdraw_amount_pending: 200,
      withdraw_amount_rejected: 450,
      total_clients: 2,
      total_positions: 500,
      transaction_chart: [200, 300, 400]
    },
    {
      agent_first_name: "Robert",
      agent_last_name: "White",
      agent_id: 25,
      deposit_count: 20,
      deposit_amount: 7000,
      deposit_amount_approved: 6500,
      deposit_amount_pending: 500,
      deposit_amount_rejected: 800,
      withdraw_amount: 2000,
      withdraw_amount_approved: 1800,
      withdraw_amount_pending: 200,
      withdraw_amount_rejected: 700,
      total_clients: 5,
      total_positions: 100,
      transaction_chart: [500, 400, 600]
    },
    {
      agent_first_name: "Emily",
      agent_last_name: "Johnson",
      agent_id: 52,
      deposit_count: 9,
      deposit_amount: 7000,
      deposit_amount_approved: 6800,
      deposit_amount_pending: 200,
      deposit_amount_rejected: 450,
      withdraw_amount: 3000,
      withdraw_amount_approved: 2800,
      withdraw_amount_pending: 200,
      withdraw_amount_rejected: 800,
      total_clients: 9,
      total_positions: 1201,
      transaction_chart: [1000, 900, 1200]
    },
    {
      agent_first_name: "David",
      agent_last_name: "Brown",
      agent_id: 53,
      deposit_count: 25,
      deposit_amount: 10000,
      deposit_amount_approved: 9500,
      deposit_amount_pending: 5000,
      deposit_amount_rejected: 300,
      withdraw_amount: 4000,
      withdraw_amount_approved: 3500,
      withdraw_amount_pending: 500,
      withdraw_amount_rejected: 150,
      total_clients: 9,
      total_positions: 21200,
      transaction_chart: [800, 1000, 1200]
    },
    {
      agent_first_name: "Sophie",
      agent_last_name: "Adams",
      agent_id: 58,
      deposit_count: 8,
      deposit_amount: 4000,
      deposit_amount_approved: 3800,
      deposit_amount_pending: 200,
      deposit_amount_rejected: 200,
      withdraw_amount: 1500,
      withdraw_amount_approved: 1400,
      withdraw_amount_pending: 100,
      withdraw_amount_rejected: 250,
      total_clients: 4,
      total_positions: 800,
      transaction_chart: [200, 300, 500]
    },
    {
      agent_first_name: "William",
      agent_last_name: "Taylor",
      agent_id: 60,
      deposit_count: 4,
      deposit_amount: 2000,
      deposit_amount_approved: 1800,
      deposit_amount_pending: 200,
      deposit_amount_rejected: 350,
      withdraw_amount: 500,
      withdraw_amount_approved: 400,
      withdraw_amount_pending: 100,
      withdraw_amount_rejected: 200,
      total_clients: 1,
      total_positions: 600,
      transaction_chart: [100, 200]
    },
    {
      agent_first_name: "Olivia",
      agent_last_name: "Martin",
      agent_id: 62,
      deposit_count: 3,
      deposit_amount: 1500,
      deposit_amount_approved: 1400,
      deposit_amount_pending: 100,
      deposit_amount_rejected: 150,
      withdraw_amount: 600,
      withdraw_amount_approved: 500,
      withdraw_amount_pending: 100,
      withdraw_amount_rejected: 250,
      total_clients: 2,
      total_positions: 900,
      transaction_chart: [300, 400]
    },
    {
      agent_first_name: "Henry",
      agent_last_name: "Turner",
      agent_id: 152,
      deposit_count: 1,
      deposit_amount: 500,
      deposit_amount_approved: 400,
      deposit_amount_pending: 100,
      deposit_amount_rejected: 250,
      withdraw_amount: 200,
      withdraw_amount_approved: 150,
      withdraw_amount_pending: 50,
      withdraw_amount_rejected: 80,
      total_clients: 3,
      total_positions: 1100,
      transaction_chart: [50, 100, 150]
    },
    {
      agent_first_name: "Sophia",
      agent_last_name: "Turner",
      agent_id: 167,
      deposit_count: 5,
      deposit_amount: 2500,
      deposit_amount_approved: 2400,
      deposit_amount_pending: 100,
      deposit_amount_rejected: 250,
      withdraw_amount: 1200,
      withdraw_amount_approved: 1100,
      withdraw_amount_pending: 100,
      withdraw_amount_rejected: 350,
      total_clients: 2,
      total_positions: 200,
      transaction_chart: [100, 150, 200]
    },
    {
      agent_first_name: "Ariana",
      agent_last_name: "Lang",
      agent_id: 168,
      deposit_count: 6,
      deposit_amount: 3000,
      deposit_amount_approved: 2800,
      deposit_amount_pending: 200,
      deposit_amount_rejected: 300,
      withdraw_amount: 1500,
      withdraw_amount_approved: 1400,
      withdraw_amount_pending: 100,
      withdraw_amount_rejected: 600,
      total_clients: 5,
      total_positions: 1000,
      transaction_chart: [250, 300, 400]
    }
  ],
  events: [
    {
      id: 1,
      agent_first_name: "Jane",
      agent_last_name: "Smith",
      avatar: "/assets/avatars/avatar-alcides-antonio.png",
      amount: 3500
    },
    {
      id: 2,
      agent_first_name: "John",
      agent_last_name: "Doe",
      avatar: "/assets/avatars/avatar-marcus-finn.png",
      amount: 4700
    },
    {
      id: 3,
      agent_first_name: "Alice",
      agent_last_name: "Johnson",
      avatar: "/assets/avatars/avatar-carson-darrin.png",
      amount: 3000
    }
  ],
  desks: [
    { label: "Desk 1", value: "desk1" },
    { label: "Desk 2", value: "desk2" },
    { label: "Desk 3", value: "desk3" },
  ],
};